import { render, staticRenderFns } from "./StatSection.vue?vue&type=template&id=cafea712&scoped=true"
import script from "./StatSection.vue?vue&type=script&lang=js"
export * from "./StatSection.vue?vue&type=script&lang=js"
import style0 from "./StatSection.vue?vue&type=style&index=0&id=cafea712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafea712",
  null
  
)

export default component.exports